/**
 * Shared spatial rhythm for the home page's content sections (everything
 * below the hero). One value per role, so a section cannot drift to its own
 * padding the way they had: 40, 64 and 80px top padding side by side.
 */

/** Vertical breathing room of a section: 64px on phones, 96px from md up. */
export const SECTION_PADDING = "py-16 md:py-24";

/**
 * Horizontal frame of a section's content. Matches the hero's edge: 16px /
 * 80px gutters, and once the viewport is wider than 1760px + gutters the
 * content stops at 1760px and centres, the same cap the hero grid uses, so
 * left edges line up down the page (tests/components/home-section-layout.test.ts
 * holds the two caps together). The cap lives in the margin value because the
 * `raw` screen in tailwind.config suppresses `min-[…]` width variants.
 * `landscape-phone:` is that raw screen, emitted after `md:`, so it wins on a
 * phone on its side: 24px, the same as the footer.
 */
export const SECTION_CONTAINER =
  "mx-4 md:mx-[max(5rem,calc((100%_-_1760px)/2))] landscape-phone:mx-6";

/** Heading → supporting copy → content: tight, then generous. */
export const SECTION_HEADING = "text-3xl md:text-4xl font-bold text-yellow-500 mb-3";

